import { Allocation } from "@/api/SolarCloudApi";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/Dialog";
import { z } from "zod";
import { useEnergyCompanies } from "@/queries/useEnergyCompanies";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import AddAllocationForm from "./AddAllocationForm";
import { Suspense, useState, useEffect } from "react";
import LoadingSection from "@/components/LoadingSection";
import { Plus } from "lucide-react";
import { cn } from "@/util/cn";
import { useSearchParams } from "react-router";

type AddAllocationDialogProps = {
  handleAddAllocation: (allocation: Allocation) => void;
  unallocatedWatts: number;
  account: "gas" | "electricity" | "bank" | undefined;
  className?: string;
};

export default function AddAllocationDialog({
  handleAddAllocation,
  unallocatedWatts,
  account,
  className,
}: AddAllocationDialogProps) {
  const { data: energyCompanies } = useEnergyCompanies();
  //TODO gas companies
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("createLink")) {
      setIsOpen(true);
      // Remove the search param after opening the dialog
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.delete("createLink");
        return newParams;
      });
    }
  }, [searchParams, setSearchParams]);

  const handleFormSubmit = (data: Allocation) => {
    setIsOpen(false);
    handleAddAllocation(data);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <div
          className={cn(
            "p-2 flex items-center justify-center rounded-full bg-brand-orange-500 border border-transparent hover:scale-105 hover:shadow-lg cursor-pointer",
            className
          )}
        >
          <Plus className="size-10 text-brand-neutral-900" />
        </div>
      </DialogTrigger>
      <DialogContent className="bg-brand-neutral-800 md:w-[600px] overflow-y-scroll max-h-screen">
        <div className="w-full md:w-sm mx-auto flex flex-col gap-y-4 py-6">
          <DialogHeader>
            <DialogTitle>
              Link My <span className="capitalize">{account}</span>
            </DialogTitle>
          </DialogHeader>
          {energyCompanies ? (
            <AddAllocationForm
              energyCompanies={energyCompanies}
              unallocatedWatts={unallocatedWatts}
              onSubmit={handleFormSubmit}
              account={account}
            />
          ) : (
            <LoadingSection />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

// const form = useForm<TSignInSchema>({
//     resolver: zodResolver(signInSchema),
//     defaultValues: {
//       email: data.email || "",
//       password: data.password || "",
//     },
//   });
